"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const storm_ui_1 = require("@amzn/storm-ui");
const regionUtils_1 = require("../../../utils/regionUtils");
const TranslationProvider_1 = require("../TranslationProvider/TranslationProvider");
const helpers_1 = require("../../../test-utils/helpers");
/**
 * RegionSwitcherSelectorDropdown
 *
 * A dropdown component for switching between accounts, used as
 * an alternative to the popper-based region switcher.
 *
 * @param id - id of the dropdown.
 * @param accounts - list of available regional accounts.
 * @param selectedRegion - the currently selected regional account.
 * @param onRegionChange - callback when a region is selected.
 */
const RegionSwitcherSelectorDropdown = ({ id, accounts, selectedRegion, onRegionChange, }) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const handleChange = (value) => {
        // Find the account that matches the selected regionId.
        const selectedAccount = accounts.find(account => account.regionId === value);
        if (selectedAccount) {
            onRegionChange(selectedAccount);
        }
    };
    const onOverrideLabel = (dropdownValue, value) => {
        const regionLabel = translate('region');
        let selectedRegionLabel;
        if (value) {
            const account = accounts.find(acc => acc.regionId === value);
            selectedRegionLabel = account ? translate((0, regionUtils_1.getRegionLabel)(account.regionId)) : dropdownValue;
        }
        else {
            selectedRegionLabel = translate((0, regionUtils_1.getRegionLabel)(selectedRegion.regionId));
        }
        return regionLabel + ': ' + selectedRegionLabel;
    };
    return ((0, jsx_runtime_1.jsx)(storm_ui_1.Dropdown, { id: id, onChange: handleChange, selectedValue: selectedRegion.regionId, onOverrideLabel: onOverrideLabel, children: accounts.map((account) => ((0, jsx_runtime_1.jsx)(storm_ui_1.DropdownItem, { value: account.regionId, "data-testid": (0, helpers_1.getRegionalDropdownItemId)(account.regionId), children: translate((0, regionUtils_1.getRegionLabel)(account.regionId)) }, account.regionId))) }));
};
exports.default = RegionSwitcherSelectorDropdown;
//# sourceMappingURL=RegionSwitcherSelectorDropdown.js.map